exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Title {\n  font-size: 18px;\n  text-align: center;\n  margin-bottom: 32px;\n  width: 100%; }\n  .Title h1.Title__Heading {\n    color: #212121;\n    margin: 0;\n    font-size: 24px; }\n  .Title h2.Title__Heading {\n    color: #212121;\n    margin: 0;\n    font-size: 20px; }\n  .Title__Legend {\n    color: #939393;\n    margin-bottom: 0;\n    font-size: 16px;\n    margin-top: 4px; }\n  .Title__Subtitle {\n    color: #212121;\n    margin-bottom: 4px;\n    font-size: 20px;\n    margin-top: 8px; }\n", ""]);

// exports
